<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.25 23.25a9.754 9.754 0 0 1 6.749-9.28l3 2.53 3-2.53a9.754 9.754 0 0 1 6.751 9.28"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M17.657 15.306a9.726 9.726 0 0 0-2.655-1.336l-3 2.53 3.4 4.075 2.255-5.269ZM12 16.5l-3-2.53a9.746 9.746 0 0 0-2.654 1.336l2.258 5.269L12 16.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="m14.25 23.25 1.146-2.675M8.603 20.575 9.75 23.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      clip-rule="evenodd"
      d="M6.75 6a5.25 5.25 0 1 0 10.5 0 5.25 5.25 0 0 0-10.5 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.476 3.334a8.725 8.725 0 0 0 9.726 1.956"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
